import React, { Component, PureComponent } from 'react'
import NavigationItems from './Components/NavigationItems'
import PageHeader from './Components/PageHeader'
import Footer from './Components/Footer'
import axios from 'axios'
import Base from './Config'
import { Modal,ButtonToolbar,Button } from 'react-bootstrap';
import { TextArea } from 'semantic-ui-react';
import Carousel from 'react-elastic-carousel';
import Item from 'react-elastic-carousel';
import { WaveLoading,
} from 'react-loadingg';
import mobile from '../assets/img/mobile_phone-512.png'
import TextareaAutosize from 'react-textarea-autosize';

import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

import {Link} from "react-router-dom";

// import ImageViewer from 'react-image-viewer-zoom'
// import 'react-image-viewer-zoom/dist/style.css' 

// import ModalImage from "react-modal-image";
import ModalImage from "./assets/Nodemodules/react-modal-image";

import { CSVLink, CSVDownload } from "react-csv";
import ToggleSwitch from './Components/ToggleSwitch'

class TransactionUpdateModal extends PureComponent {
    constructor(){
        super()
            this.state={
                amount:"",
                
            }
        // console.log("asdfghjkl",this.state.amount);
    }

    handleChange=(event)=>{
        this.setState({
            amount:event.target.value
           });
        //  console.log(this.state.amount);
        //  console.log("ddddddddddddd",this.state.amount)
        // this.props.amount('amount')
    }
   
    cancell=()=>{
        this.setState({
            amount:""
        })
        // console.log('worked no',this.props);
        // this.props.no('no')
        // this.props.amount('amount')
        this.props.onHide()
    }
    success=()=>{
        if(!this.state.amount){
            alert("Required amount")
            return false
        }
        // console.log('workedyees ',this.state.amount);
        this.props.yes('yes',this.state.amount)
        // this.props.amount('amount')
        this.props.onHide()
    }
    

    render() {
        // console.log("modal prop ",this.props)
        return (
            <Modal
            // {...this.props}
            show={this.props.show}
            onHide={this.props.onHide}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >

            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                {/* Confirmation box */}
        </Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <h2>Are you sure, you want to manually settle payment details?</h2>
                
                    {/* <TextArea name="note" value={this.state.name} onChange={this.onChange}  className="form-control form-control-lg" placeholder="Expert note"></TextArea> */}
                    <table className="table">
                        <tbody>
                            <tr>
                                <td align="right">Amount : </td>
                                <td>
                                <input name="amount"  onChange={this.handleChange}  type="number" onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()} className="form form-control" placeholder="Amount"/>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div>
                    
                </div>
                <div>
                    
                </div>
            </Modal.Body>
            
            
            <Modal.Footer>
                <Button className="btn btn-success" onClick={this.success}>Yes </Button>
                <Button className="btn btn-danger" onClick={this.cancell}>No</Button>
            </Modal.Footer>
        </Modal>
        )
    }
}

class ExportModal extends PureComponent {
    constructor(){
        super()
        this.state={
            download:false,
            // usertype:"",
            // fortenant:false,
            // foroutsider:false,
            data:[],

            fromdate:"",
            todate:"",

            loading:false,
            name:"zukhrof-order",

           


            headers:[
                { label: "Index", key: "index" },
                { label: "Order id", key: "id" },
                { label: "Order date", key: "date" },
                { label: "Order of (username)", key: "username" },
                { label: "Order of (first name)", key: "firstname" },
                { label: "User email", key: "email" },
                { label: "Mobile", key: "mobile" },
                { label: "User Type", key: "type" },
                // { label: "Service id", key: "serviceid" },
                { label: "Service name", key: "servicename" },
                { label: "Category Name", key: "categoryname" },
                { label: "Parent Category", key: "pcategory" },
                { label: "Description", key: "desc" },
                { label: "Priority", key: "priority" },
                { label: "Convinent Day", key: "day" },
                { label: "Promocode", key: "promocode" },
                { label: "Is express", key: "express" },
                // { label: "Payement status", key: "payement" },
            ]
            
        
        }
    }
    clearState=()=>{
        this.setState({
            download:false,
            fromdate:"",
            todate:"",
            data:[],

            loading:false,
            name:"zukhrof-order",
        })
    }

    cancell=()=>{
        this.clearState()
        this.props.onHide()
    }

    onChange=(e)=>{
        this.setState ({
            [e.target.name]:e.target.value
        })
    }
    generate=()=>{

        
        this.setState({
            loading:true
        })
        console.log('from date ',this.state.fromdate);
        console.log('to date ',this.state.todate);

        if(!this.state.fromdate){
            NotificationManager.warning( "Please select From date",'Warning ', 10000);
            this.setState({
                loading:false
            })
            return false
        }
        if(!this.state.todate){
            NotificationManager.warning( "Please select to date",'Warning ', 10000);
            this.setState({
                loading:false
            })
            return false
        }

        axios.get(
            Base.url + 'OrderGet/?is_quotaion_maid=0&from_dates='+this.state.fromdate+' 00:00:0&to_dates='+this.state.todate+' 00:00:0&page_wise=false',
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            NotificationManager.info("You can download now",'File Generated : ', 5000);
            var userdata = []

            console.log('Response Normal :', response.data);
            if(response.data.length===0){
                NotificationManager.info("No record found in file",'File Generated : ', 10000);
            }
            
            response.data.map((item,index)=>{
                // console.log('item ',index," : ",item," mob : ",item.mobile);

                let mobile="mob: "
                mobile = mobile+item.user_det.mobile
                userdata.push(
                    {
                        index:index+1,
                        id:item.id,
                        date:item.date,
                        username:item.user_det.user.username,
                        firstname:item.user_det.user.first_name+"("+item.user_det.ar_name+")",
                        email:item.user_det.user.email,
                        mobile:mobile,
                        type:item.user_det.user_type,
                        servicename:item.service.name+"("+item.service.ar_name+")",
                        categoryname:item.service.category.name+"("+item.service.category.ar_name+")",
                        pcategory:item.service.category.parent_name,
                        desc:item.description,
                        priority:item.priority.name,
                        promocode:item.promo_code,
                        express:item.is_express.toString(),
                        day:item.conv_day.day
                        // payement:item.,
                    }
                )
            })
            this.setState({
                data:userdata,
                loading:false,
                download:true,
            },()=>{
                // console.log('userdata ',userdata);
                
            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 3000);
        })
       

    }
    render() {
        
        return (
            <Modal
            {...this.props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >

            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Export Order data
        </Modal.Title>
            </Modal.Header>
            <Modal.Body >
            
                <table align="center" >
                    <tbody>
                    <tr>
                        <td colSpan={2}>
                            <label className="label label-primary">Please Choose date</label>
                        </td>
                        
                    </tr>
                    <tr>
                        
                        <td>
                        From date 
                        </td>
                        <td>
                            <input className="form-control" type="date" onChange={(event) => this.setState({fromdate: event.target.value,download:false})}/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                        To 
                        </td>
                        <td>
                        <input className="form-control" type="date" onChange={(event) => this.setState({todate: event.target.value,download:false})}/>
                        </td>
                    </tr>
                    <tr>
                    <td><label>file Name</label></td>
                    <td>
                    <input name="name" value={this.state.name} onChange={this.onChange} type="text" className="form form-control" placeholder="Name"/>
                    </td>

                    </tr>
                    </tbody>
                </table>
            </Modal.Body>
            <Modal.Footer>


                {this.state.loading?
                <>
                    <Button className="btn btn-danger" onClick={this.cancell}>Cancell</Button>

                    <Button className="btn btn-primary" disabled>Generating </Button>
                </>
                :
                    this.state.download?
                    <>
                    <Button className="btn btn-danger" onClick={this.cancell}>close</Button>

                    <CSVLink 
                            data={this.state.data} 
                            headers={this.state.headers}
                            filename={this.state.name+".csv"}
                            className="btn btn-success"
                            >Download
                        </CSVLink>
                    </>
                    :
                        <>
                        <Button className="btn btn-danger" onClick={this.cancell}>Cancell</Button>
                        <Button className="btn btn-primary" onClick={this.generate}>Generate</Button>
                        </>
                }
                
                

                

            </Modal.Footer>
        </Modal>
        )
    }
}

class MyVerticallyCenteredModal extends PureComponent {
    constructor(){
        super()
        this.state = {
            note:'',
            amount:'',
            days:'',
            qtn_valid_days:"",
        }
        
    }
    
    submitForm=()=>{
        // console.log('submit');
        
        if(this.state.note==""){
            NotificationManager.error( "Expert Note cannot be blank",'Error : ', 10000);
            return false
        }
        if(this.state.amount=="" ){
            NotificationManager.error( "Amount cannot be blank",'Error : ', 10000);
            return false
        }
        if(isNaN(this.state.amount) ){
            NotificationManager.error( "Amount must be a number",'Error : ', 10000);
            return false
        }
        if(this.state.days==""){
            NotificationManager.error( "Service valid Days cannot be blank",'Error : ', 10000);
            return false
        }
        if(isNaN(this.state.days) ){
            NotificationManager.error( "Service valid Days must be a number",'Error : ', 10000);
            return false
        }
        if(this.state.qtn_valid_days==""){
            NotificationManager.error( "Quotation valid Days cannot be blank",'Error : ', 10000);
            return false
        }
        if(isNaN(this.state.qtn_valid_days) ){
            NotificationManager.error( "Quotation valid Days must be a number",'Error : ', 10000);
            return false
        }
        // return false
        let data = []
        data.push({'orderid':this.props.id,'details':this.state})
        this.props.MakeQuotation(data)
        this.props.onHide()
    }

    onChange=(e)=>{
        this.setState ({
            [e.target.name]:e.target.value
        })
    }

    render() {
        return (
            <Modal
            {...this.props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Quotation Details
        </Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <div>
                    Expert Note :
                </div>
                <div>
                    <TextArea name="note" value={this.state.name} onChange={this.onChange}  className="form-control form-control-lg" placeholder="Expert note"></TextArea>
                </div>
                <div>
                    Amount :
                </div>
                <div>
                    <input name="amount" value={this.state.name} onChange={this.onChange}  type="number" onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()} className="form form-control" placeholder="Amount"/>
                </div>
                <div>
                Service valid Days :
                </div>
                <div>
                    <input name="days" value={this.state.name} onChange={this.onChange} type="number" onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()} className="form form-control" placeholder="Service valid Days" alt="hint"/>
                </div>
                <div>
                Quotation valid Days :
                </div>
                <div>
                    <input name="qtn_valid_days" value={this.state.name} onChange={this.onChange}  type="number" onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()} className="form form-control" placeholder="Quotation valid Days" alt="hint"/>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={this.submitForm}>Submit</Button>
            </Modal.Footer>
        </Modal>
        )
    }
}

class DeleteModal extends PureComponent {
    submitForm=()=>{
        // console.log(this.props.id)
        this.props.delete(this.props.id)
        this.props.onHide()
    }


    render() {
        // console.log('id ',this.props);
        
        return (
            <Modal
            {...this.props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
        <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Delete order
        </Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <h2>You want to delete this order? </h2>
                

                
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn btn-success" onClick={this.submitForm}>Yes</Button>
                <Button className="btn btn-danger" onClick={this.props.onHide}>No</Button>
            </Modal.Footer>
            {/* <React.Fragment>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Export User data
            </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <h2>You want to delete this order? </h2>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn btn-success" onClick={this.submitForm}>Yes</Button>
                    <Button className="btn btn-danger" onClick={this.props.onHide()}>No</Button>
                </Modal.Footer>
            </React.Fragment> */}
        </Modal>
        )
    }
}

class FilterModal extends React.PureComponent {
    constructor(){
        super()
        this.state = {
            category:"",
            days:"",
            priority:"",
            express:"",
            old:"",
        }
    }
    
    submitForm=()=>{
    
        // let data = []
        // data.push({'orderid':this.props.id,'details':this.state})
        this.props.makefilter(this.state.category,this.state.days,this.state.priority,this.state.express,this.state.old)
        this.props.onHide()
        this.clear()
        
    }
    clear(){
        this.setState({
            category:"",
            days:"",
            priority:"",
            express:"",
        })
    }

    handleChange = (e)=> {
        this.setState({
            [e.target.name]:e.target.value
        });
    }

    render() {
        const category = this.props.category
        const days = this.props.days
        const priority = this.props.priority
        const express = this.props.express
        // console.log('days ',days);
        
        // const options = [
        //     'one', 'two', 'three'
        //   ];
        //   const defaultOption = options[0];
        
        return (
            <Modal
            {...this.props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                   Advanced Filtering
        </Modal.Title>
            </Modal.Header>
            <Modal.Body >

                <div>
                Select category  :
                </div>
                <div>
                    {/* <Dropdown options={category} onChange={this._onSelect} value={defaultOption} placeholder="Select an option" />; */}
                    <div className="form-group">
                        <select name="category" value={this.state.category} onChange={this.handleChange} className="form-control-sm form-control" style={{borderColor:'#fafafa',boxShadow:'0px 2px 1px #ededed',paddingLeft:18}}  >
                            <option value='' disabled>Select category</option>
                        { category.map((option,index) =>{
                        return <option key={index} value={option.id} >{option.name}</option>
                        }
                        )}
                        </select>
                    </div>
                </div>
                <div>
                Is Express service :
                </div>
                <div>
                    <div className="form-group">
                        <select name="express" value={this.state.express} onChange={this.handleChange} className="form-control-sm form-control" style={{borderColor:'#fafafa',boxShadow:'0px 2px 1px #ededed',paddingLeft:18}}  >
                            <option value='' disabled>Select servcie type</option>
                        { express.map((option,index) =>{
                        return <option key={index} value={option.id} >{option.name}</option>
                        }
                            )}
                        </select>
                    </div>
                </div>
                <div>
                Select Priority  :
                </div>
                <div>
                    <div className="form-group">
                        <select name="priority" value={this.state.priority} onChange={this.handleChange} className="form-control-sm form-control" style={{borderColor:'#fafafa',boxShadow:'0px 2px 1px #ededed',paddingLeft:18}}  >
                            <option value='' disabled>Select Priority</option>
                        { priority.map((option,index) =>{
                        return <option key={index} value={option.id} >{option.name}</option>
                        }
                            )}
                        </select>
                    </div>                    
                </div>
                <div>
                Select day   :
                </div>
                <div>
                    <div className="form-group">
                        <select name="days" value={this.state.days} onChange={this.handleChange} className="form-control-sm form-control" style={{borderColor:'#fafafa',boxShadow:'0px 2px 1px #ededed',paddingLeft:18}}  >
                            <option value='' disabled>Select day</option>
                        { days.map((option,index) =>{
                        return <option key={index} value={option.id} >{option.day}</option>
                        }
                            )}
                        </select>
                    </div>    
                </div>
                <div>
                Order by :
                </div>
                <div>
                    <div className="form-group">
                        <select name="old" value={this.state.old} onChange={this.handleChange} className="form-control-sm form-control" style={{borderColor:'#fafafa',boxShadow:'0px 2px 1px #ededed',paddingLeft:18}}  >
                            <option value='' disabled>Select day</option>
                            <option value='d' >Latest</option>
                            <option value='a' >Oldest</option>
                        </select>
                    </div>    
                </div>
                {/* <div>
                from_date   :
                </div>
                <div>
                    <input name="days" value={this.state.name} onChange={this.onChange}  type="text" className="form form-control" placeholder="Valid Days" alt="hint"/>
                </div>
                <div>
                to_date   :
                </div>
                <div>
                    <input name="days" value={this.state.name} onChange={this.onChange}  type="text" className="form form-control" placeholder="Valid Days" alt="hint"/>
                </div> */}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={this.submitForm}>Done</Button>
            </Modal.Footer>
        </Modal>
        )
    }
}

class Items extends PureComponent {
    constructor(){
        super()
        this.state={
            open:false,
            modalShow:false,
            deleteModal:false,
            modalopen:false,

            edit:false,
            data:[],

            id:'',
            selectedOption:"",

            orderid:"",

            notifyUser: false,
            
        }
        this.OnToggle = this.OnToggle.bind(this);

    }
    
    getDays(){
        axios.get(
            Base.url + 'ConvDay/?is_active=1&page_wise=0',
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            // console.log('Response all :', response);
            console.log('Response all :', response.data);

            this.setState({
                data: response.data,
                
            }
            // ,()=>console.log(this.state.data)
            )

        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    onChange=(e)=>{
        this.setState ({
            [e.target.name]:e.target.value
        })
    }

    setStatus=()=>{
        this.setState({
            modalShow:true,
            deleteModal:false,
        })
    }

    openDel=()=>{
        // console.log('Delete');
        
        this.setState({
            deleteModal:true,
            modalShow:false,
        },()=>{
            // console.log('modal del open',this.state.deleteModal);
            
        })
    }

    toggle() {
        // console.log('readit ',this.props.quotation.id);
        
        this.setState({
          open: !this.state.open
        });
    }

    callActivateParentFunction=()=>{
        console.log('id ',this.props.quotation.id);
        this.props.ManageUsers(this.props.quotation.id,'actv')
    }

    callDeactivateParentFunction=()=>{
        console.log('id ',this.props.quotation.id);
        this.props.ManageUsers(this.props.quotation.id,'dactv')
    }

    MakeQuotation=(data)=>{
        this.props.read(this.props.quotation.id)
        // console.log('MakeQuotation Data : ',data);
        // this.props
        // console.log("parent :",this.props.MakeQuotation(data));
        this.props.MakeQuotation(data)
        // console.log('orderid : ',orderid);   
        // console.log('details : ',details);
    }

    edit=()=>{
        this.getDays()

        // console.log('Edit ',this.props.quotation);
        this.setState({
            edit:true,
            selectedOption:this.props.quotation.conv_day.id,
            id:this.props.quotation.id
        })
        // this.props.Edit(this.props.data)
    }
    save=()=>{
        // orderid
        // dayid
        // console.log("id ",this.state.id);
        // console.log("selected ",this.state.selectedOption);
        
        this.setState({
            edit:false
        })
        this.props.updateDay(this.state.id,this.state.selectedOption)
    }
    handleChange=(event)=> {
        this.setState({
            selectedOption: event.target.value
        },
        ()=>console.log('state changed :',this.state.selectedOption)
        );
      }
    download=(file,filename)=>{
       console.log('file ',file);
       

       axios({
        url: file.replace(/^http:\/\//i, 'https://'),
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename+'.jpg');
        document.body.appendChild(link);
        link.click();
      });
}

    
modalopen=(data)=>{
    // console.log('data',data);
    this.setState({
        modalopen:true,
        orderid :data,


        
        // quotaionid:event.target.id,
        // quotaionStatus:event.target.name,
      })
    // alert("datasssssss")
  }
  
  transactionUpdate=(result ,amount)=>{
    // console.log("orderid ", this.state.orderid);
//    console.log("amoundmanual",amount);
  var today = new Date();

  var date = today.getDate()+'-'+(today.getMonth()+1)+'-'+today.getFullYear();
  var curDate = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate()+" 00:00:00"
  var tid = "admin_"+date
//   console.log(tid);
    
   


    if(result==="yes"){
    //   console.log(this.props.refreshData);
    //   return 0
      const data = new FormData()
      data.append('keyword', 'update_payment');
      data.append('order_id', this.state.orderid);
      data.append('transaction_id', tid);
      data.append('transaction_date', curDate);
      data.append('amount', amount);
      data.append('status', 'success');
      var config = {
      method: 'patch',

      url: Base.url + 'Order/',
      headers: { 
          'Authorization': 'Token ' + localStorage.getItem('Token'),
      },
      data : data
          
      };
      axios(config)
      .then(function (response) {

        if(response.data.Status){
            NotificationManager.success( response.data.Message,'Success : ',3000)                    
        }else{
            console.log(response.data.Message);
            NotificationManager.error('Error : ', response.data.Error, 3000)
        }
        //   this.props.refreshData()
    //   console.log(JSON.stringify(response.data));
      })
      .catch(function (error) {
        NotificationManager.error('Error : ', error, 3000)

      console.log(error);
      });
      
      var config = {
      method: 'patch',

      url: Base.url + 'Order/',
      headers: { 
          'Authorization': 'Token ' + localStorage.getItem('Token'),
      },
      data : data
          
      };
      axios(config)
      .then(function (response) {

        if(response.data.Status){
            NotificationManager.success( response.data.Message,'Success : ',3000)                    
        }else{
            console.log(response.data.Message);
            NotificationManager.error('Error : ', response.data.Error, 3000)
        }
        //   this.props.refreshData()
    //   console.log(JSON.stringify(response.data));
      })
      .catch(function (error) {
        NotificationManager.error('Error : ', error, 3000)

      console.log(error);
      });


    }
    else{
      console.log("false");
    }
    // console.log('props in transaction update',this.props.refreshData());
    this.props.refreshData()
    
}
    // kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk



    OnToggle(value,order_id) {
        
        this.setState({notifyUser: value})
        // console.log("Order id .",order_id)
        // return
        var fdata = new FormData();
        fdata.set('is_acknowledged', value)
        fdata.set('keyword', 'update_acknowledgement')
        fdata.set('order_id', order_id)

        var config = {
            method: 'patch',
      
            url: Base.url + 'Order/',
            headers: { 
                'Authorization': 'Token ' + localStorage.getItem('Token'),
            },
            data : fdata,
                
            };

            

            axios(config)
            .then(function (response) {
                console.log(response)
              if(response.data.Status){
                  NotificationManager.success( '','Success : ',3000)                    
              }else{
                  console.log(response.data.Message);
                  NotificationManager.error('Error : ', response.data.Error, 3000)
              }
              //   this.props.refreshData()
          //   console.log(JSON.stringify(response.data));
            })
            .catch(function (error) {
              NotificationManager.error('Error : ', error, 3000)
      
            console.log(error);
            });
    }

    componentDidMount(){
        this.setState({notifyUser:this.props.quotation.is_acknowledged})
    }

    render() {

        // console.log('notify user',this.state.notifyUser)



        // console.log('props : ',this.props.quotation);
        const data = this.props.quotation
        var date = new Date(data.date)
        // console.log('payement ',data.id);
        // console.log('imgssaa:',data.images);
        const images = [
            { src: data.images, title: 'title', content: 'content' }
        ]

        var orderDate = date 
        var today = new Date();
        
        // To calculate the time difference of two dates 
        var Difference_In_Time = today.getTime() - orderDate.getTime(); 
  
        // To calculate the no. of days between two dates 
        var Difference_In_Days =  parseInt(Difference_In_Time / (1000 * 3600 * 24)) 
        var className = ""
        if(Difference_In_Days<=5){
            className="label h5 opacity-3 "
        }
        else if(Difference_In_Days<=10){
            className="label h5 opacity-5 text-green"
        }
        else if(Difference_In_Days<=15){
           className="label h5 opacity-7 text-orange"
        }else{
            className="label h5  text-red"
        }

        return (
           <>
           <tr bgcolor="">
                <th scope="row"> 
                {data.is_new?<>
                    <span style={{cursor:"pointer"}} onClick={()=>this.props.read(this.props.quotation.id)} title="Mark as read"><i className="fas fa-check-double text-green"></i></span>
                    &nbsp; 
                <i className={`fa fa-${this.state.size}x fa-exclamation blink text-red `} >
                    New</i>
                
                <br/></>:""}
                <label className="opacity-5 h4 text-truncate">{data.id}-&nbsp;</label>
                
                <label className=" h4 text-truncate" style={{maxWidth:'100px'}} title={data.service.name} >{data.service.name}</label>
                <br/>
                <label className={className}>{Difference_In_Days} days ago</label>
                </th>
                <td scope="row">{data.service.category.name}</td>
                <td>{data.priority.name}</td>
                <td>{data.is_express?<label className="badge badge-dot"><i className="bg-success" /> Yes</label>:<label className="badge badge-dot mr-4"><i className="bg-warning" /> No</label>}</td>
                <td>
                    {!this.state.edit?
                    <>
                    {data.conv_day.day}
                    <button className="btn-sm btn-outline-primary ml-2" onClick={this.edit}>
                    <i className="fas fa-edit " ></i>
                    </button>
                    </>
                    :
                    <>
                    <select value={this.state.selectedOption} onChange={this.handleChange} className="form form-control-sm w-auto" style={{borderColor:'#fafafa',boxShadow:'0px 2px 1px #ededed'}}  name="user_type" >
                    {/* value={this.state.user_type} onChange={this.onChange} */}
                    <option value='' disabled>Select day</option>
                    { this.state.data.map((option,index) => <option key={index} value={option.id} >{option.day}</option>)}
                    {/* <option  value="O" >Outsider</option>
                    <option  value="T" >Tenant</option> */}
                    </select>

                    {/* <input type='text' className="form form-control-sm w-75" value={data.conv_day.day} name="day" ></input>  */}
                    <button className="btn-sm btn-outline-success" onClick={this.save}>
                    <i className="fas fa-check" ></i>
                    </button>
                    </>
                    }
                    
                    


                </td>
                <td>
                    {
                    data.payment== null?<label className="text-danger">Not paid</label>:
                    data.payment.status==="Payment Processing"?
                    <button onClick={()=>this.modalopen(data.id)} className="ml-2 btn btn-sm btn-warning">{data.payment.status}</button>
                    :
                    <label className="text-success text-capitalize">{data.payment.status}</label>
                    }
                    
                </td>
                <td>
                    <button name="make" className="btn btn-sm btn-success" onClick={this.setStatus} title="Make Quotation"><i className="fas fa-check" ></i></button>
                

                <MyVerticallyCenteredModal
                    show={this.state.modalShow}
                    id={data.id}
                    
                    MakeQuotation={this.MakeQuotation}

                    onHide={() => this.setState({ modalShow: false }
                        // ,console.log('MakeQuotation')
                        )}
                />

                                
                <TransactionUpdateModal
                    // orderid={this.state.orderid}
                    show={this.state.modalopen}
                    yes={this.transactionUpdate}
                    no={this.transactionUpdate}
                    
                    // MakeQuotation={this.MakeQuotation}

                    onHide={() => this.setState({ modalopen: false })}
                />
                
                {/* <div className="btn btn-sm" onClick={this.toggle.bind(this)}>{this.state.open?<i className="fa fa-close text-red" ></i>:<i className="fa fa-info text-blue" ></i>}</div> */}
                    <br/>
                    <br/>
                    <button name="delete" className="btn btn-sm btn-danger" title="delete order" onClick={this.openDel}><i  className="fas fa-trash"></i></button>
                    
                    <DeleteModal
                        show={this.state.deleteModal}
                        // show={true}
                        delete={this.props.delete}

                        id={data.id}
                        onHide={() => this.setState({ deleteModal: false }
                            // ,console.log('deleteModal')
                        )}
                    />
                </td>
                <td>
                {/* this.makeitread() */}
                <div className="btn btn-md" title={this.state.open?"shrink details":"expand details"} onClick={this.toggle.bind(this)}>{this.state.open?<i className="fa fa-close text-red" ></i>:<i className="fa fa-info text-blue" ></i>}</div>
               
                </td>
            </tr>
            {this.state.open?
                <tr style={{ backgroundColor: 'rgb(231, 231, 231)' }}>
                    <td colSpan={1}>
                        
                        {data.images.length>0?
                        // <img height={70} width={100} src={data.images.image} />
                        
                        <>    

{/* multiple image set                                   */}
<Carousel>
        {data.images.map((item,index) => <div key={item.image} style={{height: 60, width: '47', overflow: 'fix'}} >
         {/* <img height={70} width={100} src={data.images.image} /> */}
            <ModalImage
                small={item.image}
                large={item.image}
                alt={data.user_det.user.username+"-"+data.service.name}
                hideDownload={true}
                showRotate={true}
            
            />
                </div>

                
        )}
        
    
            {/* <img 
                src={item.image}
                alt={item.id}
            /> */}

     


        {/* <div key={1}>
        
        </div>
        <div key={1}>title</div>
        <div key={1}>title</div>
        */}
      </Carousel>



                          
                            {/* <br/> */}
                            {/* <div style={{cursor:"pointer"}}onClick={()=>this.download(data.images,data.user_det.user.username+"-"+data.service.name)} > <i className="fa fa-download" /> &nbsp;download</div> */}
                        </>
                        :
                        "No image"
                         }
                        
                    </td>
                    <td colSpan={2}>
                        
                    <ToggleSwitch label={'Notify user'} value={this.state.notifyUser} onchange={(notifyUser)=> this.OnToggle(notifyUser,data.id)}
              />
                        <b>{data.user_det.user_type=='O'?"Outsider":"Tenant"} </b> : {data.user_det.user.username} <br />
                        <br/>
                        <label className=" h4 text-justify " style={{maxWidth:'40px'}} title={data.service.name} >{data.service.name}</label>

                        {data.user_det.user_type=='T'?
                        <div>
                            Door no : {data.address?.door_no} <br />
                            Building no : {data.address?.building_no} <br />
                            Location : {data.address?.location} <br />
                            
                        </div>
                        :<>
                        Address :
                        
                        <TextareaAutosize
                            className="form form-control"
                            readOnly
                            minRows={3}
                            maxRows={6}
                            defaultValue={data.address?.location}
                            />
                        </>
                        }
                        Mobile : {data.user_det.mobile}<br />
                        
                        {/* <i className="fa fa-home text-blue"></i> : {data.address.door_no} <br /> */}
                        {/* <i className="fa fa-building " aria-hidden="true"></i> : {data.address.building_no} <br /> */}
                        {/* <i className="fa fa-map-marker text-red" aria-hidden="true"></i> : {data.address.location} <br /> */}
                        {/* <img src={mobile} /> : {data.user_det.mobile}<br /> */}
                        {/* <i className="fa fa-mobile text-black" aria-hidden="true"></i> : {data.user_det.mobile}<br /> */}
                        {/* Type : <b>{data.user_det.user_type=='O'?"Outsider":"Tenant"} </b><br /> */}
                    </td>
                    <td colSpan={2}>
                        Order date : {date.toDateString()}<br />
                        {/* Order time : {date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds()}<br /> */}
                        Order time : {date.toLocaleTimeString()}<br />
                        {/* Description : <textarea readOnly className="form form-control" style={{maxWidth: 250}}  value={data.description} ></textarea> <br /> */}
                        Description :   <TextareaAutosize
                                        className="form form-control"
                                        readOnly
                                        minRows={3}
                                        maxRows={6}
                                        defaultValue={data.description}
                                        />
                      
                    </td>
                    <td colSpan={3}>
                        {
                        data.payment == null?
                        "No Payement Details"
                        :
                         <>
                            Transaction id : {data.payment.transaction_id} <br />
                            Transaction date : {data.payment.transaction_date} <br />
                            Amount : {data.payment.amount} <br />
                            Payement Status : {data.payment.status} <br />
                        </>
                        }
                        
                    </td>
                    {/* <td></td>
                    <td></td> */}
                </tr>
                :
                <></>
                }
           </>
        )
    }
}


export default class Orders extends Component {
    constructor(){
        super()
        this.state={
            data:[],
            next:null,
            prev:null,
            loading:true,

            tenant:false,
            outsider:false,

            modalShow:false,
            exportModal:false,
            filtermodal:false,

            filter:null,

            filterData:[],
            categorys:[],
            days:[],
            priority:[],
            express:[],

            categoryid:"",
            dayid:"",
            priorityid:"",
            expressid:"",
            search_text:"",
            order_by_date:"",


        }
    }

    setStatus=(event)=>{
    
        this.setState({
          modalShow:true,
        })
        
        // console.log('worked id:',event.target.id);
        // console.log('worked name:',event.target.name);
    }

    componentDidMount(){
        // console.log("componentDidMount");
        
        this.fetchAllData()
        // this.fetchFilterData()
    }
    fetchFilterData(){
        axios.get(
            Base.url + 'DropDowns/?category=1&priority=1&days=1&express=1',
            { 
                headers: { 
                  'Authorization': 'Token '+localStorage.getItem('Token'),
                } 
            }
          ).then(response =>{
            console.log('filter data ',response.data);
            
            this.setState({
              filterData:response.data,
            })
          })
          .catch(error =>{
              NotificationManager.error('Error : ', error, 3000);
          })

    }
    componentWillMount(){
        // console.log("componentWillMount");
    }
    componentDidUpdate(){
        // console.log("componentDidUpdate");
        // this.fetchAllData()
    }

    next=()=>{
        this.setState({
            loading:true
        })
        axios.get(
          this.state.next.replace(/^http:\/\//i, 'https://'),
          { 
              headers: { 
                'Authorization': 'Token '+localStorage.getItem('Token'),
              } 
          }
        ).then(response =>{
          this.setState({
            data:response.data.results,
            next:response.data.next,
            prev:response.data.previous,
            loading:false, 

          })
        })
        .catch(error =>{
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    prev=()=>{
        this.setState({
            loading:true
        })
        axios.get(
          this.state.prev.replace(/^http:\/\//i, 'https://'),
          { 
              headers: { 
                  'Authorization': 'Token '+localStorage.getItem('Token'),
              } 
          }
        ).then(response =>{
          this.setState({
            data:response.data.results,
            next:response.data.next,
            prev:response.data.previous,
            loading:false,
          })
        })
        .catch(error =>{
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    fetchAllData=()=>{
        // this.setState({
        //     loading:true
        
        // })
        axios.get(
            Base.url + 'OrderGet/?is_quotaion_maid=0&from_date&to_date&search_text='+this.state.search_text+'&priority_list='+this.state.priorityid+'&is_express='+this.state.expressid+'&category_id='+this.state.categoryid+'&conv_day_id ='+this.state.dayid+'&order_by_date='+this.state.order_by_date,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            // console.log('Response all :', response);
            // console.log('Response fetchAllData :', response.data.results);
            axios.get(
            Base.url + 'DropDowns/?category=1&priority=1&days=1&express=1',
            { 
                headers: { 
                    'Authorization': 'Token '+localStorage.getItem('Token'),
                } 
            }
            ).then(responseFilter =>{
            // console.log('filter data ',responseFilter.data);
            // console.log('filter data ',responseFilter.data.category);
            
                this.setState({
                    filterData:responseFilter.data,
                    categorys:responseFilter.data.category,
                    priority:responseFilter.data.priority,
                    days:responseFilter.data.days,
                    express:responseFilter.data.express,

                    data: response.data.results,
                    next: response.data.next,
                    prev: response.data.previous,
                    loading:false,

                    // filter:false,
                    tenant:false,
                    outsider:false,
                })
            })
            .catch(error =>{
                NotificationManager.error('Error : ', error, 3000);
            })
            

        }).catch(error => {
            // console.log('Error loading quotation count: ', error);
            
            NotificationManager.error('','Network error occured', 3000);
        })

    }
    readAll=()=>{
        this.fetchAllData()
    }

    fetchTenant=()=>{
        console.log('worked tenant');
        
        axios.get(
            Base.url + 'OrderGet/?is_quotaion_maid=0&from_date&to_date&users_list=&priority_list=&service_list=&user_type=T&is_quotaion_maid=0',
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            // console.log('Response all :', response);
            // console.log('Response all :', response.data.results);

            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                tenant:true,
                outsider:false,
                filter:"Tenants",
            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    fetchOutsiders=()=>{
        // console.log('worked outsider');
        
        axios.get(
            Base.url + 'OrderGet/?from_date&to_date&users_list=&priority_list=&service_list=&user_type=O&is_quotaion_maid=0',
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            // console.log('Response all :', response);
            // console.log('Response all :', response.data.results);

            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                tenant:false,
                outsider:true,
                filter:'Outsiders',
            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 3000);
        })
    }
    MakeQuotation = (data)=>{
        this.setState({
            loading:true
        })
        // console.log("Grand parent MakeQuotation ",data[0]);
        // console.log("Grand parent MakeQuotation ",data[0].orderid);
        // console.log("Grand parent MakeQuotation ",data[0].details.qtn_valid_days);

        // return false;
                
        var bodyFormData = new FormData();
        bodyFormData.set('Order_id', data[0].orderid);
        bodyFormData.set('exp_opinion', data[0].details.note);
        bodyFormData.set('amount', data[0].details.amount);
        bodyFormData.set('reopen_valid_days', data[0].details.days);
        bodyFormData.set('qtn_valid_days', data[0].details.qtn_valid_days);

        axios.post(
            Base.url + 'Quotation/',
            bodyFormData,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
        .then(response =>{
            // console.log('response : ',response);
                if(response.data.Status){
                    NotificationManager.success( response.data.Message,'Success : ',3000)
                    this.setState({
                        loading:false
                    })
                    this.fetchAllData()
                }else{
                    console.log(response.data.Message);
                    NotificationManager.error('Error : ', response.data.Error, 3000)

                    this.setState({
                        loading:false
                    })
                }
        })
        .catch(error=>{
            console.log(error);
            this.setState({
                loading:false
            })
        })
    }

    orderReadApi=(id)=>{
        // console.log('read it',id);
        // console.log('filter ',this.state.filter);
        
        
        var bodyFormData = new FormData();
        bodyFormData.set('keyword', "set_as_read");
        bodyFormData.set('order_id_list', id);

        axios.patch(
            Base.url + 'Order/',
            bodyFormData,
        {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
        .then(response =>{
            // console.log('response : ',response);
                if(response.data.Status){
                    // this.fetchAllData()


                    if(this.state.filter==="Tenants"){
                        this.fetchTenant()
                        // console.log("call all");
                    }
                    else if(this.state.filter==="Outsiders"){
                        this.fetchOutsiders()
                        // console.log("call outsider");
                    }
                    else{
                        this.fetchAllData()
                        // console.log("call tenand");
                    }

                    // console.log(response.data.Message);
                    
                }else{
                    // console.log(response.data.Message);
                    
                }
        })
        .catch(error=>{
            console.log(error);
        })
    }

    updateDay=(orderid,dayid)=>{
        // console.log("orderid ",orderid);
        // console.log("dayid ",dayid);

                
        var bodyFormData = new FormData();
        bodyFormData.set('id', orderid);
        bodyFormData.set('conv_day_id', dayid);

        axios.put(
            Base.url + 'Order/',
            bodyFormData,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
        .then(response =>{
            // console.log('response : ',response);
                if(response.data.Status){
                    // console.log(response.data.Message)
                    if(this.state.filter===false){
                        this.fetchAllData()
                        // console.log("call all");
                    }
                    else if(this.state.filter==="Outsiders"){
                        this.fetchOutsiders()
                        // console.log("call outsider");
                    }
                    else{
                        this.fetchTenant()
                        // console.log("call tenand");
                    }
                }else{
                    console.log(response.data.Message);
                    NotificationManager.error('Error : ', response.data.Error, 3000)

                }
        })
        .catch(error=>{
            console.log(error);
        })
        
    }
    makefilter=(category,days,priority,express,old)=>{
        // console.log("category",category);
        // console.log("days",days);
        // console.log("priority",priority);
        // console.log("express",express);
        this.setState({
            categoryid:category,
            dayid:days,
            priorityid:priority,
            expressid:express,
            order_by_date:old,
            filter:"enabled",
        },()=>this.fetchAllData())
    }
    clearFilters=()=>{
        this.setState({
            categoryid:"",
            dayid:"",
            priorityid:"",
            expressid:"",
            filter:"",
            search_text:"",
            order_by_date:"",
        },()=>{this.fetchAllData()})
    }
    onChange=(e)=>{
        this.setState({
           [e.target.name]:e.target.value
        })
    }
    search=()=>{
        this.setState({
            filter:"enabled",
        },()=>this.fetchAllData())
    }

    handleKeyPress=(e)=> {
        if(e.charCode==13){
          this.search();    
        } 
    }

      
    deleteOrder = (id)=>{
        // console.log('Delete parent data ',data);
        
        axios.delete(
            Base.url + `Order/?id=${id}`,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
        .then(response =>{
            // console.log('response : ',response);
                if(response.data.Status){
                    NotificationManager.success( response.data.Message,'Success : ',3000)                    
                    this.fetchAllData()
                    // this.loading(false)
                }else{
                    console.log(response.data.Message);
                    NotificationManager.error('Error : ', response.data.Error, 3000)

                    // this.loading(false)

                }
        })
        .catch(error=>{
            console.log(error);
        })
    }

    // deleteOrder=(id)=>{

       
    //     axios.delete(
    //         Base.url + `Order/?id=${id}`,
    //         {
    //             headers: {
    //                 'Authorization': 'Token ' + localStorage.getItem('Token'),
    //             }
    //         }
    //     )
    //     .then(function (response) {
    //     console.log(JSON.stringify(response.data));
    //     console.log('order deleted ',id);
    //     // this.readAll()

    //     })
    //     .catch(function (error) {
    //     console.log(error);
    //     });
    //     this.fetchAllData()

    // }
      

    render() {
        return (
            <div>
                {/* <NotificationContainer/> */}

                <NavigationItems />
                {/* Main content */}
                <div className="main-content">
                    <PageHeader pageName="Orders" />
                    <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8">
                        <div className="container-fluid">
                            <div className="header-body">
                                {/* Card stats */}
                                <div className="row">
                                    <div className="col-xl-3 col-lg-6">
                                        <div className="input-group input-group-alternative mb-3">
                                            <input name="search_text" value={this.state.search_text} 
                                            onKeyPress={this.handleKeyPress}
                                            onChange={this.onChange} className="form-control " placeholder="Search Service or Category" type="text" />
                                            <button type="submit" className="btn btn-sm btn-white " onClick={this.search}><i className="fa fa-search" aria-hidden="true"></i></button>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Page content */}
                    <div className="container-fluid mt--7">
                        {/* Table */}
                        <div className="row">
                            <div className="col">

                                <div className="card shadow">
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }} className="card-header border-0">
                                        <div style={{ flex: 1, height: '100%' }}>
                                            {this.state.filter&&<button className="btn btn-sm bg-translucent-secondary" onClick={this.clearFilters}>clear filter</button>} 
                                            <b>Orders</b>
                                            {/* {this.state.filter&&<span className="text-muted text-sm">{' / '+this.state.filter}</span>}  */}
                                            <div className={this.state.filter?"text-blue":""} style={{cursor:"pointer"}} onClick={()=>
                                                this.setState({ filtermodal: true })
                                                }>Advanced filtering</div>

                                                <FilterModal
                                                    show={this.state.filtermodal}
                                                    makefilter={this.makefilter}

                                                    category={this.state.categorys}
                                                    express={this.state.express}
                                                    days={this.state.days}
                                                    priority={this.state.priority}

                                                    onHide={() => this.setState({ filtermodal: false })}
                                                />

                                        </div>
                                        {this.state.loading?'':
                                        <div style={{ height: '100%', flex: 1, justifyContent: 'center', display: 'flex', flexDirection: 'row' }}>
                                            <div  className="test1" style={{ cursor: 'pointer',boxShadow: '0px 1px 2px 0px grey', padding: 10, display: 'flex', height: '100%', flex: 1, justifyContent: 'center', borderBottomLeftRadius: 10, borderTopLeftRadius: 10,backgroundColor:this.state.tenant?'#6072E4':'white',color:this.state.tenant?'white':'black' }} onClick={this.fetchTenant} >Tenant</div>
                                            <div  className="test1" style={{ cursor: 'pointer',boxShadow: '0px 1px 2px 0px grey', padding: 10, display: 'flex', flex: 1, justifyContent: 'center', borderBottomRightRadius: 10, borderTopRightRadius: 10,backgroundColor:this.state.outsider?'#6072E4':'white',color:this.state.outsider?'white':'black' }} onClick={this.fetchOutsiders} >Outsider</div>
                                        </div>
                                        }
                                        <div style={{ flex: 1 }}><h3 className="mb-0" /> </div>
                                        {this.state.prev==null?<button disabled={true} className="btn btn-sm btn-primary">Prev</button>:<button className="btn btn-sm btn-primary" onClick={this.prev}>Prev</button>}
                                        {this.state.next==null?<button disabled={true} className="btn btn-sm btn-primary">Next</button>:<button className="btn btn-sm btn-primary" onClick={this.next}>Next</button>}
                                    </div>
                                   
                                    <div className="table-responsive">
                                    {this.state.loading?<WaveLoading/>:
                                        <table className="table align-items-center table-flush">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th scope="col">Service Name</th>
                                                    <th scope="col">Category</th>
                                                    <th scope="col">Priority</th>
                                                    <th scope="col">Is Express</th>
                                                    <th scope="col">Convenient day</th>
                                                    <th scope="col">Paid</th>
                                                    <th scope="col" >Action</th>
                                                    <th scope="col" >
                                                    <ExportModal
                                                     show={this.state.exportModal}
                                                     onHide={() => this.setState({ exportModal: false })}
                                                    />
                                                    <button title="Export data" className="btn btn-sm " onClick={() => this.setState({ exportModal: true })}>
                                                    <i className="fas fa-file-export" />  
                                                    </button>

                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {this.state.data.map((data,index)=> 
                                                <Items 
                                                    key={index} 
                                                    quotation={data} 
                                                    MakeQuotation={this.MakeQuotation}
                                                    read = {this.orderReadApi}
                                                    updateDay={this.updateDay}
                                                    refreshData = {this.fetchAllData}
                                                    delete={this.deleteOrder}
                                                />
                                                )
                                            }
                                            </tbody>
                                        </table>
                                    }
                                    </div>
                                    
                                </div>
                            
                            </div>
                        </div>
                        {/* Dark table */}
                        {/* Footer */}
                        <Footer />
                    </div>
                </div>
            </div>

        )
    }
}
